<div class="documentation-container">
  <div class="documentation-header">
    <h1 class="text-3xl font-bold text-gray-800 mb-2">
      <i class="fas fa-book mr-3 text-blue-600"></i>
      Documentación del Sistema
    </h1>
    <p class="text-gray-600 mb-6">
      Accede a toda la documentación técnica y procesos del sistema AutoComercialDelNorte
    </p>
  </div>

  <div class="documentation-content">
    <!-- Filtros por categoría -->
    <div class="category-filters mb-6">
      <div class="flex flex-wrap gap-2">
        <button
          (click)="setCategory('all')"
          [class.active]="selectedCategory === 'all'"
          class="px-4 py-2 rounded-lg border transition-colors duration-200 hover:bg-blue-50 hover:border-blue-300">
          <i class="fas fa-list mr-2"></i>Todas
        </button>
        <button
          *ngFor="let category of categories"
          (click)="setCategory(category)"
          [class.active]="selectedCategory === category"
          class="px-4 py-2 rounded-lg border transition-colors duration-200 hover:bg-blue-50 hover:border-blue-300">
          <i class="fas fa-folder mr-2"></i>{{ category }}
        </button>
      </div>
    </div>

    <!-- Contenido principal -->
    <div class="documentation-main">
      <!-- Lista de archivos -->
      <div class="documentation-sidebar" *ngIf="!selectedFile">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">
          <i class="fas fa-file-alt mr-2 text-blue-600"></i>
          Archivos Disponibles
        </h2>

        <!-- Archivos por categoría -->
        <div *ngIf="selectedCategory === 'all'">
          <div *ngFor="let category of categories" class="category-section mb-6">
            <h3 class="text-lg font-medium text-gray-700 mb-3 border-b pb-2">
              <i class="fas fa-folder-open mr-2 text-blue-500"></i>
              {{ category }}
            </h3>
            <div class="file-list">
              <div *ngFor="let file of getFilesByCategory(category)"
                   (click)="selectFile(file)"
                   class="file-item p-4 border rounded-lg cursor-pointer hover:bg-blue-50 hover:border-blue-300 transition-colors duration-200">
                <div class="flex items-start">
                  <i class="fas fa-file-alt text-gray-500 mr-3 mt-1"></i>
                  <div class="flex-1">
                    <h4 class="font-medium text-gray-800">{{ file.title }}</h4>
                    <p class="text-sm text-gray-600 mt-1">{{ file.description }}</p>
                    <div class="text-xs text-gray-500 mt-2">
                      <i class="fas fa-file-code mr-1"></i>{{ file.name }}
                    </div>
                  </div>
                  <i class="fas fa-chevron-right text-gray-400 ml-2"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vista por categoría seleccionada -->
        <div *ngIf="selectedCategory !== 'all'">
          <div class="file-list">
            <div *ngFor="let file of getFilteredFiles()"
                 (click)="selectFile(file)"
                 class="file-item p-4 border rounded-lg cursor-pointer hover:bg-blue-50 hover:border-blue-300 transition-colors duration-200">
              <div class="flex items-start">
                <i class="fas fa-file-alt text-gray-500 mr-3 mt-1"></i>
                <div class="flex-1">
                  <h4 class="font-medium text-gray-800">{{ file.title }}</h4>
                  <p class="text-sm text-gray-600 mt-1">{{ file.description }}</p>
                  <div class="text-xs text-gray-500 mt-2">
                    <i class="fas fa-file-code mr-1"></i>{{ file.name }}
                  </div>
                </div>
                <i class="fas fa-chevron-right text-gray-400 ml-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista del archivo seleccionado -->
      <div class="documentation-viewer" *ngIf="selectedFile">
        <div class="viewer-header mb-6">
          <button (click)="selectedFile = null"
                  class="mb-4 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200">
            <i class="fas fa-arrow-left mr-2"></i>Volver a la lista
          </button>

          <div class="file-info bg-white p-4 rounded-lg border">
            <h2 class="text-2xl font-bold text-gray-800 mb-2">{{ selectedFile.title }}</h2>
            <p class="text-gray-600 mb-3">{{ selectedFile.description }}</p>
            <div class="file-meta text-sm text-gray-500">
              <span class="mr-4">
                <i class="fas fa-folder mr-1"></i>{{ selectedFile.category }}
              </span>
              <span class="mr-4">
                <i class="fas fa-file-code mr-1"></i>{{ selectedFile.name }}
              </span>
            </div>
          </div>
        </div>

        <div class="file-content bg-white p-6 rounded-lg border">
          <div class="mb-4 p-4 bg-green-50 border-l-4 border-green-400">
            <div class="flex items-center justify-between">
            <div class="flex items-center">
              <i class="fas fa-check-circle text-green-400 mr-2"></i>
              <div class="text-sm">
                <p class="font-medium text-green-800">Documentación renderizada</p>
                <p class="text-green-700">Contenido Markdown convertido a formato visual optimizado</p>
              </div>
            </div>
              <a [href]="getGitHubUrl(selectedFile)"
                 target="_blank"
                 class="px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600 transition-colors">
                <i class="fas fa-external-link-alt mr-1"></i>Ver en GitHub
              </a>
            </div>
          </div>

          <!-- Loading indicator -->
          <div *ngIf="loading" class="flex items-center justify-center py-12">
            <div class="flex items-center space-x-3">
              <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              <span class="text-gray-600">Cargando documentación...</span>
            </div>
          </div>

          <!-- Markdown content -->
          <div *ngIf="!loading && htmlContent" class="markdown-content" [innerHTML]="htmlContent"></div>

          <!-- Error state -->
          <div *ngIf="!loading && !markdownContent && selectedFile" class="text-center py-12">
            <i class="fas fa-exclamation-triangle text-yellow-500 text-4xl mb-4"></i>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Error al cargar la documentación</h3>
            <p class="text-gray-600 mb-4">
              No se pudo cargar el contenido del archivo. Esto puede deberse a problemas de conexión.
            </p>
            <button (click)="selectFile(selectedFile)"
                    class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              <i class="fas fa-refresh mr-2"></i>Intentar nuevamente
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
